class TdNavigationBar extends HTMLElement {
  constructor() {
    super();
    this.filterContainer = null;
    this.init();
  }

  init() {
    // Find the filter container on the page
    this.filterContainer = document.querySelector('filter-container');
    
    if (!this.filterContainer) {
      console.warn('TD Navigation Bar: filter-container not found on page');
      return;
    }

    this.setupFilterListeners();
    this.updateActiveStates();
  }

  setupFilterListeners() {
    // Listen for clicks on filter links
    const filterLinks = this.querySelectorAll('.td-navigation-bar__link--filter');
    
    filterLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleFilterClick(link);
      });
    });
  }

  handleFilterClick(link) {
    const item = link.closest('.td-navigation-bar__item');
    let filterUrl = item.dataset.filterUrl;
    if(!item.classList.contains('td-navigation-bar__item--active')) {
      filterUrl = item.dataset.filterUrl + "?" + item.dataset.filterParam + '=' + item.dataset.filterValue;
    }

    if (!filterUrl) {
      console.warn('TD Navigation Bar: Missing filter data attributes');
      return;
    }

    this.filterContainer.dispatchEvent(new CustomEvent('custom:filter:selected', {
      detail: {
        filterUrl: filterUrl
      },
        bubbles: true
    }));
  }

  updateActiveStates(urlParams = false) {
    if (!urlParams) {
      urlParams = new URLSearchParams(window.location.search);
    }
    const navigationItems = this.querySelectorAll('.td-navigation-bar__item[data-filter-param]');
    navigationItems.forEach(item => {
      const filterParam = item.dataset.filterParam;
      const filterValue = item.dataset.filterValue;
      
      if (filterParam && filterValue) {
        const currentValue = encodeURIComponent(urlParams.get(filterParam));
        const isActive = currentValue === filterValue;
        
        item.classList.toggle('td-navigation-bar__item--active', isActive);
      }
    });
  }

  handleFiltersUpdate(evt) {
    // Handle filters:update event from main.js
    if (evt.detail && evt.detail.url) {
      const url = new URL(evt.detail.url, window.location.origin);
      const urlParams = new URLSearchParams(url.search);
      this.updateActiveStates(urlParams)
    }
  }

  // Listen for filter changes from the filter container
  connectedCallback() {
    // Initialize active states when component loads
    this.updateActiveStates();
    // Listen for filters:update event from main.js
    document.addEventListener('filters:update', this.handleFiltersUpdate.bind(this));
  }
}

// Register the custom element
if (!customElements.get('td-navigation-bar')) {
  customElements.define('td-navigation-bar', TdNavigationBar);
}
